import * as React from 'react';

const FlowerSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.6 13.9h-.2c-.7 0-3 .1-4.4 1.5-.2.2-.4.4-.5.7v-3c2-.2 3.5-1.9 3.5-4V2l-2.3 2L12 2.3 10.3 4 8 2v7.3c.1 2 1.6 3.6 3.5 3.8v3c-.2-.2-.3-.5-.5-.7-1.4-1.4-3.7-1.5-4.4-1.5h-.2s-.2 2.9 1.5 4.6c1.1 1.1 2.6 1.4 3.6 1.5v2h1v-2c1-.1 2.5-.4 3.6-1.5 1.7-1.7 1.5-4.6 1.5-4.6zm-9 3.9c-.8-.8-1.1-2-1.2-2.8.8.1 2 .4 2.8 1.2.8.8 1.1 2 1.2 2.8-.8-.2-2-.4-2.8-1.2zm2.5-13.1l.9-.9.9.9-1 .9-.8-.9zM9 4.2l2.2 2-1 .9L9 8.2v-4zm0 5.3l1.9-1.7L15 4.2v4.9c0 1.7-1.3 3-3 3-1.5 0-2.8-1.1-3-2.6zm3.6 9.4c.1-.8.4-2 1.2-2.8.8-.8 2-1.1 2.8-1.2-.1.8-.4 2-1.2 2.8-.8.9-2 1.1-2.8 1.2z"
        />
    </svg>
);

FlowerSvg.displayName = 'FlowerSvg';
export default FlowerSvg;
